import { Input } from '@/components/Input';
import { selectHomeandContents, setHomeandContents } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'HomeandContents';

export function HomeandContents({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectHomeandContents);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        // MAXIMUM
        const MAXIMUM = 999999999;
        const intValue: number | undefined = getNumber(value, MAXIMUM);
        if (intValue && intValue > MAXIMUM) return;
        if (intValue === currentState) return;
        dispatch(setHomeandContents(intValue));
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title='Home & contents'
                showErrors={showErrors && !currentState}
                onChange={handleChange}
                id={`${baseId}-input-purchasePrice`}
                value={currentState?.toLocaleString() ?? ''}
                placeholder=''
                prefix='$'
                showNumpad={true}
                tooltipContent='The value of your furniture, appliances, jewellery and other household contents.'
            />
        </div>
    );
}
